const contactInfo = [
  {
    label: "Address",
    icon: "ri-map-pin-2-line",
    lines: ["Matoseva ulica 50", "City Solin", "Zip 21210", "Country Croatia"],
  },
  {
    label: "Email",
    icon: "ri-mail-line",
    lines: ["info@bobisdoo.com"],
  },
  {
    label: "Phone",
    icon: "ri-phone-line",
    lines: ["+1 7407497106"],
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="py-28" style={{ background: "#F5F0EB" }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="mb-16">
          <span className="text-xs uppercase tracking-[0.25em] text-[#999] font-medium">/ Contact</span>
          <h2 className="text-4xl md:text-5xl font-thin text-[#2A2A2A] mt-3 leading-tight">
            Get in Touch
          </h2>
          <p className="text-[#888] text-base font-light mt-3 max-w-md leading-relaxed">
            Have questions about our products or want to learn more about BOBIS d.o.o.? We&apos;d love to hear from you.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10">
          {/* Contact Cards */}
          <div className="flex flex-col sm:flex-row lg:flex-col gap-6 lg:w-80">
            {contactInfo.map((item) => (
              <div
                key={item.label}
                className="bg-white rounded-2xl p-6 border border-gray-100 flex-1 lg:flex-none"
                style={{ boxShadow: "0 4px 20px rgba(0,0,0,0.04)" }}
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-[#f0ebe5]">
                    <i className={`${item.icon} text-[#8a7060] text-lg`} />
                  </div>
                  <span className="text-xs uppercase tracking-widest text-[#aaa] font-medium">{item.label}</span>
                </div>
                <div className="flex flex-col gap-0.5">
                  {item.lines.map((line) => (
                    <span key={line} className="text-sm text-[#444] font-light leading-relaxed">
                      {line}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Map / Visual */}
          <div className="flex-1 rounded-3xl overflow-hidden min-h-[400px] relative">
            <img
              src="https://public.readdy.ai/ai/img_res/adfb3213acf4273ae717022f0fe4902a.jpg"
              alt="Solin, Croatia"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            <div className="absolute bottom-6 left-6 text-white">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-fill text-red-400 text-base" />
                </div>
                <span className="text-sm font-semibold">Solin, Croatia</span>
              </div>
              <p className="text-xs text-white/70 font-light">Matoseva ulica 50, 21210</p>
            </div>
          </div>
        </div>

        {/* Footer bar */}
        <div className="mt-16 pt-8 border-t border-[#e0d8d0] flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/32a11129-5612-4a46-a525-ad474434d5f3.png"
              alt="BOBIS d.o.o."
              className="h-7 w-auto object-contain"
            />
            <span className="text-sm text-[#888] font-light">BOBIS d.o.o.</span>
          </div>
          <p className="text-xs text-[#aaa] font-light text-center sm:text-right">
            &copy; {new Date().getFullYear()} BOBIS d.o.o. All rights reserved. &nbsp;|&nbsp; iOS Development Studio &nbsp;|&nbsp; Solin, Croatia
          </p>
        </div>
      </div>
    </section>
  );
}
